import { defineComponent as _defineComponent } from 'vue'
import {useCacheStore} from "@/pinia";
import {FILTERS, ISignalFilter, ISignalFilters} from "@/shared";
import {computed, onBeforeMount, onMounted, ref} from "vue";
import FilterOperator from "@/components/automation/filters/FilterOperator.vue";
import FilterGeneric from "@/components/automation/filters/FilterGeneric.vue";
import FiltersGeneric from "@/components/automation/filters/FiltersGeneric.vue";
import FilterAddModal from "@/components/automation/filters/FilterAddModal.vue";
import SignalLinkModal from "@/components/automation/signals/SignalLinkModal.vue";

// props
interface IProps {
	availableFilters: ISignalFilters,
	setFilters: ISignalFilters,
	minRequired?: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersGeneric',
  props: {
    availableFilters: null,
    setFilters: null,
    minRequired: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	availableFilters: ISignalFilters,
	setFilters: ISignalFilters,
	minRequired?: number,
};



// store
const cacheStore = useCacheStore();

// data
const FilterAddModalRef = ref<InstanceType<typeof FilterAddModal> | null>(
	null
);

const filters = ref<ISignalFilters>([])

// computed
const unusedAvailableFilters = computed<ISignalFilters>(() => {
	const used = {}
	filters.value.forEach((v) => {
		used[v.key] = true
	})

	return props.availableFilters.filter(f => !used[f.key])
})

// methods
function showFilterAdd() {
	FilterAddModalRef.value?.show();
}

function onAddFilter(f) {
	filters.value.push(f)
}

function onFilterDelete(e) {
	filters.value = filters.value.filter(f => f.key !== e.key)
}

onBeforeMount(() => {
	if (props.setFilters) {
		filters.value = props.setFilters
	}
	if (props.availableFilters.length === 1 && props.minRequired === 1)
		filters.value.push(props.availableFilters[0])
})

// expose
expose({data: filters.value});

return { __sfc: true,props, cacheStore, FilterAddModalRef, filters, unusedAvailableFilters, showFilterAdd, onAddFilter, onFilterDelete, FilterOperator, FilterAddModal }
}

})